
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import URI from 'urijs';

import ObjectValidationResult from '../ObjectValidationResult';

let resolve;

class DialogDocumentLink extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogDocumentLink />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            description: '',
            title: '',
            url: ''
        };
    }

    getIsValid = () => {
        return (this.getValidationItems().length === 0);
    }

    getValidationItems = () => {
        let items = [];
        if (!this.state.url) {
            items.push('URL adresa dokumentu není zadaná');
        }
        if (this.state.url && !this.isValidHttpUrl(this.state.url)) {
            items.push('URL adresa dokumentu není správně zadaná');
        }
        if (!this.state.title) {
            items.push('Název dokumentu není zadaný');
        }
        return items;
    }

    isValidHttpUrl = (string) => {
        let isValid = false;
        try {
            const uri = new URI(string);
            if (uri) {
                isValid = true;
                const PROTOCOLS = ['http', 'https', 'file'];
                isValid = isValid && (PROTOCOLS.indexOf(uri.protocol()) !== -1);
                isValid = isValid && uri.hostname();
            }
        } catch (err) {
            // nop;
        }
        return isValid;
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(false);
    }

    handleOk = () => {
        if (this.getIsValid()) {
            this.setState({hidden: true});
            resolve({
                description: this.state.description,
                title: this.state.title,
                url: this.state.url
            });
        }
    }

    handleKeyDown = (evt) => {
        if (evt.keyCode === 13) {
            this.handleOk();
        }
    }

    handleSetDescription = (evt, value) => {
        this.setState({
            description: value
        });
    }

    handleSetTitle = (evt, value) => {
        this.setState({
            title: value
        });
    }

    handleSetUrl = (evt, value) => {
        this.setState({
            url: value
        });
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    title: 'Zadejte parametry pro odkaz na dokument',
                    type: DialogType.normal
                }}
                modalProps={{
                    isBlocking: true,
                    dragOptions: {}
                }}
                >
                {this.renderContent()}
                <DialogFooter>
                    <PrimaryButton onClick={this.handleOk} text="Ok" disabled={!this.getIsValid()} />
                    <DefaultButton onClick={this.handleCancel} text="Zavřít" />
                </DialogFooter>
            </Dialog>
        );
    }

    renderContent = () => {
        return (
            <Stack>
                <TextField
                    label="URL adresa dokumentu"
                    value={this.state.url}
                    onChange={this.handleSetUrl}
                    onKeyDown={this.handleKeyDown}
                />
                <TextField
                    label="Název dokumentu"
                    value={this.state.title}
                    onChange={this.handleSetTitle}
                    onKeyDown={this.handleKeyDown}
                />
                <TextField
                    label="Popis dokumentu (volitelné)"
                    multiline
                    rows={3}
                    value={this.state.description}
                    onChange={this.handleSetDescription}
                />
                <ObjectValidationResult
                    detailed={true}
                    items={this.getValidationItems()}
                    showValidText={false}
                />
            </Stack>
        );
    }

    show(url, title, description) {
        this.setState({
            hidden: false,
            url,
            title,
            description: description || ''
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogDocumentLink.create();
